import {
    DATE_FORMAT,
} from '../../utils/dates';

/**
 * Thin wrapper around `<input type="date">`. The browser owns the display
 * format (locale-dependent) and the calendar-picker affordance. The wire
 * value is ISO `yyyy-mm-dd`, matching what the rest of the app expects.
 *
 *      <DateInput id="birthDate" name="birthDate"
 *                 value={formData.birthDate}
 *                 onChange={handleChange}
 *                 onBlur={handleBlur}
 *                 className="cr-input" />
 *
 * `onChange` receives a synthetic event with `e.target.name` and
 * `e.target.value` (ISO), matching a native input.
 */
export default function DateInput({
    id,
    name,
    value,
    onChange,
    onBlur,
    className = '',
    disabled = false,
    required = false,
    autoComplete = 'off',
    max,
    min,
    ...rest
}) {
    return (
        <input
            {...rest}
            id={id}
            name={name}
            type="date"
            autoComplete={autoComplete}
            placeholder={DATE_FORMAT}
            required={required}
            disabled={disabled}
            max={max}
            min={min}
            aria-label={rest['aria-label'] || (id || name)}
            className={className}
            value={value || ''}
            onChange={(e) =>
                onChange?.({ target: { name, value: e.target.value, type: 'date' } })
            }
            onBlur={onBlur}
        />
    );
}
